module.exports = __webpack_public_path__ + "img/cf.2255e54e.svg";